<template>

  <div class="form-client FormClient.vue full-container block">
    <div class="form__content">
      <a href="javascript:void(0);" class="go-back" @click="goBack">
        <arrowBack id="arrow-back"></arrowBack>
      </a>

      <h1 class="title-primary animated fadeInDown delay1000ms">Você está no caminho certo <span class="sub">!</span></h1>

      <h2 class="text-second animated fadeInDown delay1000ms">
        Mas antes, precisamos de algumas informações para que possamos te conhecer melhor:
      </h2>
      <!-- /.text-second -->

<!--      <h1 class="title-primary">Pra finalizar, preenche teus dados.</h1>-->

      <form @submit="goToThanksPage">
        <div class="form-group fake-label">
          <input v-fakelabel @keyup="chekEmptyField" v-model="form.name" type="text" class="bold-control"
                 placeholder="Nome" maxlength="50" autocomplete="both" required>
          <label>Nome</label>
        </div>
        <div class="form-group fake-label">
          <input v-fakelabel @keyup="chekEmptyField" v-model="form.email" type="email" class="bold-control"
                 placeholder="E-mail" maxlength="50" required autocomplete="both">
          <label>E-mail</label>
        </div>

        <div class="form-group fake-label">
          <input v-fakelabel pattern="[0-9]{2} [0-9]{4}.[0-9]{4}([0-9])?" @keyup="chekEmptyField" @blur="chekEmptyField"
                 type="text" class="bold-control phone" placeholder="00 0000.00000" maxlength="13" required autocomplete="both">
          <label>Telefone</label>
        </div>

        <div class="form-group fake-label">
          <input v-model="form.company" v-fakelabel @keyup="chekEmptyField" type="text" class="bold-control" placeholder="Nome da sua empresa" maxlength="50" required autocomplete="both">
          <label>Nome da sua empresa</label>
        </div>

        <div class="form-group fake-label">
          <input v-model="form.cargo" v-fakelabel @keyup="chekEmptyField" type="text" class="bold-control" placeholder="Cargo" maxlength="40" required autocomplete="both">
          <label>Cargo</label>
        </div>

        <div class="form-group">
          <select v-model="form.como_podemos_ajudar" :class="{'active': form.como_podemos_ajudar}" name="como_podemos_ajudar" class="bold-control" required>
            <option value="">Como podemos te ajudar?</option>
            <option>Quero fazer o um site/ecommerce</option>
            <option>Quero fazer marketing digital</option>
            <option>Outros</option>
          </select>
          <label >Como podemos te ajudar?</label>
          <!-- /#.bold-control -->
        </div>
        <!-- /.form-group -->


        <div class="form-group checklist" v-if="form.como_podemos_ajudar === 'Quero fazer marketing digital'">
          <h5>Qual seu objetivo em contratar a Bold?</h5>
          <div class="form-check" v-for="(value, key) in objetivos">
            <input v-model="objetivos[key]" type="checkbox" class="form-check-input bold-control" :id="'seg'+key" name="interesse" :value="value" :required="!objetivosValidos">
            <label class="form-check-label" :for="'seg'+key">{{ key }}</label>
          </div>
        </div>
        <!-- /.form-group -->

        <div v-if="form.como_podemos_ajudar && form.como_podemos_ajudar !== 'Quero fazer o um site/ecommerce'" class="form-group">
          <select v-model="form.em_qual_segmento_a_sua_empresa_atua" :class="{'active': form.em_qual_segmento_a_sua_empresa_atua}" name="como_podemos_ajudar" class="bold-control" required>
            <option value="">Qual seu segmento?</option>
            <option>Hospitalidade - Resort / Hotel / Pousada</option>
            <option>Clínicas - Saúde / Estética / Beleza</option>
            <option>Outros</option>
          </select>
          <label for="">Qual seu segmento?</label>
        </div>
        <!-- /.form-group -->

        <div v-if="form.em_qual_segmento_a_sua_empresa_atua === 'Hospitalidade - Resort / Hotel / Pousada'" class="hotel-wrapper">
          <div class="form-group">
            <select v-model="form.qual_seu_negocio_hotel" :class="{'active': form.qual_seu_negocio_hotel}" name="qual_seu_negocio_hotel" class="bold-control" required>
              <option value="">Qual tipo de hotel?</option>
              <option>Somos um Hotel</option>
              <option>Somos um Resort</option>
              <option>Somos uma Pousada</option>
            </select>
            <label for="">Qual tipo de hotel?</label>
          </div>
          <!-- /.form-group -->

          <div class="form-group fake-label">
            <input v-model="form.quantidade_acomodacao" v-fakelabel @keyup="chekEmptyField" type="text" class="bold-control" placeholder="Número de acomodações" maxlength="50" required autocomplete="both">
            <label>Número de acomodações</label>
          </div>

          <div class="form-group fake-label">
            <input v-model="form.ticket_medio_por_reserva" v-fakelabel @keyup="chekEmptyField" type="text" class="bold-control" placeholder="Ticket médio por reserva" maxlength="50" required autocomplete="both">
            <label>Ticket médio por reserva</label>
          </div>

          <div class="form-group">
            <select v-model="form.quanto_investe_em_midia" :class="{'active': form.quanto_investe_em_midia}" class="bold-control" required>
              <option value="">Qual a verba de mídia?</option>
              <option>Não invisto, mas quero investir</option>
              <option>Entre R$1 mil e R$5 mil</option>
              <option>Entre R$5 mil e R$10 mil</option>
              <option>Entre R$10 mil e R$20 mil</option>
              <option>Entre R$20 mil e R$30 mil</option>
              <option>Entre R$30 mil e R$40 mil</option>
              <option>Acima de R$50 mil</option>
            </select>
            <label for="">Qual a verba de mídia?</label>
          </div>
          <!-- /.form-group -->

        </div>
        <!-- /.hotel-wrapper -->

        <div v-if="form.em_qual_segmento_a_sua_empresa_atua === 'Clínicas - Saúde / Estética / Beleza'" class="clinica-wrapper">

          <div class="form-group fake-label">
            <input v-model="form.clinica_total_unidades" v-fakelabel @keyup="chekEmptyField" type="text" class="bold-control" placeholder="Quantas unidades?" maxlength="10" required autocomplete="both">
            <label>Quantas unidades?</label>
          </div>

          <div class="form-group">
            <select v-model="form.quanto_investe_em_midia" :class="{'active': form.quanto_investe_em_midia}" class="bold-control" required>
              <option value="">Qual a verba de mídia?</option>
              <option>Não invisto, mas quero investir</option>
              <option>Entre R$1 mil e R$5 mil</option>
              <option>Entre R$5 mil e R$10 mil</option>
              <option>Entre R$10 mil e R$20 mil</option>
              <option>Entre R$20 mil e R$30 mil</option>
              <option>Entre R$30 mil e R$40 mil</option>
              <option>Acima de R$50 mil</option>
            </select>
            <label for="">Qual a verba de mídia?</label>
          </div>
          <!-- /.form-group -->


          <div class="form-group">
            <select v-model="form.equipe_comercial_call_center_clinica" :class="{'active': form.equipe_comercial_call_center_clinica}" name="" class="bold-control" required>
              <option value="">Possui equipe comercial/call center?</option>
              <option>Sim, até 2 pessoas.</option>
              <option>Sim, entre 3 e 5 pessoas.</option>
              <option>Sim, mais de 5 pessoas.</option>
              <option>Não tenho equipe comercial.</option>
            </select>
            <label for="">Possui equipe comercial/call center?</label>
          </div>
          <!-- /.form-group -->

          <div class="form-group checklist">
            <h5>Quais ferramentas você utiliza para potencializar suas vendas?</h5>
            <div class="form-check" v-for="(value, key) in ferramentas">
              <input v-model="ferramentas[key]" type="checkbox" class="form-check-input bold-control" :id="'cal'+key" name="interesse" :value="value" :required="!ferramentasValidas">
              <label class="form-check-label" :for="'cal'+key">{{ key }}</label>
            </div>
          </div>
          <!-- /.form-group -->

          <div class="form-group">
            <select v-model="form.quantos_leads_por_mes_sua_empresa_gera" :class="{'active': form.quantos_leads_por_mes_sua_empresa_gera}" name="" class="bold-control" required>
              <option value="">Quantos leads geram por mês?</option>
              <option>Não sei informar</option>
              <option>Ainda não gero leads</option>
              <option>Até 50 leads</option>
              <option>Até 100 leads</option>
              <option>Até 300 leads</option>
              <option>Até 500 leads</option>
              <option>Até 1000 leads</option>
              <option>Mais de 1000 leads</option>
            </select>
            <label>Quantos leads geram por mês?</label>
          </div>

        </div>
        <!-- /.clinica-wrapper -->


        <div v-if="form.em_qual_segmento_a_sua_empresa_atua === 'Outros'" class="outros-wrapper">
          <div class="form-group fake-label">
            <input v-model="form.segmento_outro" v-fakelabel @keyup="chekEmptyField" type="text" class="bold-control" placeholder="Informe qual seu segmento" maxlength="50" required autocomplete="both">
            <label>Qual seu segmento?</label>
          </div>

          <div class="form-group fake-label">
            <input v-model="form.cargo" v-fakelabel @keyup="chekEmptyField" type="text" class="bold-control" placeholder="Cargo" maxlength="40" required autocomplete="both">
            <label>Cargo</label>
          </div>
        </div>
        <!-- /.outros-warpper -->

        <div class="form-group fake-label textarea" v-if="form.em_qual_segmento_a_sua_empresa_atua || form.como_podemos_ajudar === 'Quero fazer o um site/ecommerce'">
          <textarea v-fakelabel @keyup="chekEmptyField" v-model="form.Mensagem" @keydown="resizeTextarea"
                    class="bold-control" placeholder="Alguma outra informação que queira compartilhar?" minlength="2"
                    maxlength="1024"></textarea>
          <label>Alguma outra informação que queira compartilhar?</label>
        </div>

        <button type="submit" class="btn btn-bold btn-lg btn-padding-lg">enviar</button>
      </form>

    </div>
  </div>
  <!--</transition>-->
</template>

<script>

  import arrowBack from '../arrowBack.vue'
  import mask from 'jquery-mask-plugin';

  export default {
    name: 'FormClient',
    data() {
      return {
        contactType: '',
        objetivos: {
          'Aumentar as vendas da minha empresa': false,
          'Gerar leads para equipe de vendas': false,
          'Promover minha marca, criando autoridade e reconhecimento': false,
          'Lançar um produto (projeto especial)': false,
          'Outros objetivos': false,
        },
        ferramentas:{
          'Whatsapp': false,
          'Ferramenta de automação de emails': false,
          'CRM': false,
        },
        form: {
          name: '',
          email: '',
          telefone: '',
          company: '',
          como_podemos_ajudar: '',
          em_qual_segmento_a_sua_empresa_atua: '',
          segmento_outro: '',

          qual_seu_negocio_hotel: '',
          quantidade_acomodacao: '',
          ticket_medio_por_reserva: '',
          cargo: '',
          quanto_investe_em_midia: '',

          clinica_total_unidades: '',
          equipe_comercial_call_center_clinica: '',
          quantos_leads_por_mes_sua_empresa_gera: '',

          Mensagem: ''
        }
      }
    },
    watch: {
      'form.como_podemos_ajudar'(){
        setTimeout(()=>{
          this.preCadastro()
        }, 100)
      }
    },
    computed:{
      objetivosValidos(){
        return Object.keys(this.objetivos).filter((key)=>{
          return this.objetivos[key];
        }).join(', ')
      },
      ferramentasValidas(){
        return Object.keys(this.ferramentas).filter((key)=>{
          return this.ferramentas[key];
        }).join(', ')
      }
    },
    components: {
//      MainMenu,
      arrowBack
    },
    mounted() {
      this.log('mounted: ' + this.$options.name);
      // seta a classe do menu principal
      this.$store.commit('setMenuClass', '');

      let $this = this;
      $('.phone').mask('00 0000.00009', {
        placeholder:'Telefone',
        onChange(val) {
          $this.form.Telefone = val;
        },
      });
      window.scrollTo(0, 0);
    },
    beforeDestroy() {
      $('.phone').unmask();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },

      getPostData(identificador){
        let postData = [
          {name: 'identificador', value: identificador},
          {name: 'tok'+'en_rds'+'tation', value: '76d813f385092cd1'+'c7a5e954a4c73c5e'},
        ];

        Object.keys(this.form).forEach( (key) => {
          if (this.form[key]){
            postData.push({
              name: key,
              value: this.form[key]
            })
          }
        })

        if (this.objetivosValidos) {
          postData.push({
            name: 'quais_os_seus_objetivos_com_o_marketing_digital',
            value: this.objetivosValidos
          })
        }

        if (this.ferramentasValidas) {
          postData.push({
            name: 'ferramentas',
            value: this.ferramentasValidas
          })
        }
        return postData
      },
      preCadastro(){
        if (!form.como_podemos_ajudar){
          return;
        }
        let postData = this.getPostData('pre_contato_cliente')
        RdIntegration.post(postData);
      },
      goToThanksPage(event){
        let $this = this;
        event.preventDefault();
        window.scroll(0,0);

        let postData = this.getPostData('contato_cliente')


        $('.loading').removeClass('hideL');

        RdIntegration.post(postData, function () {
          $this.$router.push('/thanks');
        });

        return false;
      },
      resizeTextarea(event) {
        let el = event.target;
        setTimeout(function () {
          el.style.cssText = 'height:auto;';
          el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
        }, 0);
      },
      chekEmptyField(event) {
        let el = $(event.target);
        if (el.val().length > 0) {
          el.parent().addClass('white');
        } else {
          el.parent().removeClass('white');
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.form__content{
  h1{
    font-size: 36px;
  }
  h5{
    color: #fbbc33;
    margin-bottom: 15px;
    font-size: 17px;
  }
}
.checklist{
  display: flex;
  flex-wrap: wrap;
  padding-left: 15px;
  .form-check{
    width: 100%;
    margin-bottom: 12px;
    padding-left: 40px;
    input{
      display: inline-block;
      width: auto;
    }
    label{
      position: relative;
      top: initial !important;
      bottom: initial;
      font-size: 16px;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/FormClient.vue